import axios from "axios";
import app from "../main";
import store from "../store";
import { getToken, getSecret } from "@/utils/auth";

let HOST = process.env.HOST;
// HOST = HOST === "prod" ? "" : "-dev.local";
HOST = HOST === "prod" ? "" : "-test";
let baseURL = `https://api${HOST}.wfq2020.com`;

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.BASE_API,
  baseURL, // 测试
  // baseURL: "https://api.wfq2020.com", // 正式
  // baseURL: 'https://api-dev.local.wfq2020.com', // 开发
  timeout: 12000, // 请求超时时间
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
});

// request拦截器
service.interceptors.request.use(
  config => {
    const secretKey = getSecret();
    if (secretKey && secretKey !== undefined) {
      config.headers["cweb-login-secret-key"] = secretKey; // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    const ticketid = getToken();
    if (ticketid !== null && ticketid !== undefined) {
      config.headers["CWEB-TICKETID"] = ticketid; // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为03,04是登录失效 可结合自己业务进行修改
     */
    if (response.data.result === "03" || response.data.result === "04") {
      app.$router.push({
        name: "login"
      });
      store.dispatch("LogOut");
      // removeSecret()
      // removeName()
      // removeToken()
      // store.state.user.user_name = ''
    }
    return response;
  },
  error => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    service
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
/**
 * post方法，对应post请求 body传参
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    service
      .post(url, params, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js